import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrinter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 2.8C6 2.35817 6.35817 2 6.8 2H13.2C13.6418 2 14 2.35817 14 2.8V6H6V2.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.4 6H15.6C16.9255 6 18 7.07452 18 8.4V12.6C18 13.9255 16.9255 15 15.6 15H4.4C3.07452 15 2 13.9255 2 12.6V8.4C2 7.07452 3.07452 6 4.4 6ZM5.4 12H14.6V15H5.4V12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.4 12H14.6V18H5.4V12ZM6.8 13.4H13.2V16.6H6.8V13.4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.9,
			cy: 8.2,
			r: .8,
			fill: "currentColor"
		})
	]
});
export default SvgPrinter;
